import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const token = localStorage.getItem('access_token');
    if (token != null) {
      if ("mockToken" == token) {
        return true;
      }
      let jwtHelper = new JwtHelperService();

      if (!jwtHelper.isTokenExpired(token)) {
        if (route.data.expectedRoles == null) {
          return true;
        }
        const expectedRoles: Array<String> = route.data.expectedRoles;

        let tokenPayload = jwtHelper.decodeToken(token);
        const roles: String[] = tokenPayload.roles;
        if (expectedRoles.some(v => roles.includes(v))) {
          return true;
        }
      }
      else {
        localStorage.clear();
      }
    }

    this.router.navigate(['/dashboard']);
    return false;
  }

}
